import React from "react";
import type { ToastType } from "./types.ts";

const ICON_STYLE: React.CSSProperties = {
  animation: "icon-pop 0.45s cubic-bezier(0.34,1.56,0.64,1) forwards",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

function SuccessIcon() {
  return (
    <div style={ICON_STYLE}>
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="10" fill="currentColor" fillOpacity="0.15" />
        <circle cx="11" cy="11" r="10" stroke="currentColor" strokeWidth="1.5" />
        <path
          d="M6.5 11.5L9.5 14.5L15.5 8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="22"
          strokeDashoffset="22"
          style={{ animation: "check-draw 0.4s ease forwards 0.2s" }}
        />
      </svg>
    </div>
  );
}

function ErrorIcon() {
  return (
    <div style={ICON_STYLE}>
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="10" fill="currentColor" fillOpacity="0.15" />
        <circle cx="11" cy="11" r="10" stroke="currentColor" strokeWidth="1.5" />
        <path
          d="M7.5 7.5L14.5 14.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="10"
          strokeDashoffset="10"
          style={{ animation: "x-draw 0.25s ease forwards 0.2s" }}
        />
        <path
          d="M14.5 7.5L7.5 14.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="10"
          strokeDashoffset="10"
          style={{ animation: "x-draw 0.25s ease forwards 0.3s" }}
        />
      </svg>
    </div>
  );
}

function WarningIcon() {
  return (
    <div style={ICON_STYLE}>
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
        <path
          d="M11 2L20.5 19H1.5L11 2Z"
          fill="currentColor"
          fillOpacity="0.15"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path d="M11 9V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="11" cy="16" r="1" fill="currentColor" />
      </svg>
    </div>
  );
}

function InfoIcon() {
  return (
    <div style={ICON_STYLE}>
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="10" fill="currentColor" fillOpacity="0.15" />
        <circle cx="11" cy="11" r="10" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 10V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="11" cy="7.5" r="1" fill="currentColor" />
      </svg>
    </div>
  );
}

function LoadingIcon() {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        aria-hidden="true"
        style={{ animation: "icon-spin 0.75s linear infinite" }}
      >
        <circle cx="11" cy="11" r="9" stroke="currentColor" strokeWidth="2" strokeOpacity="0.2" />
        <path
          d="M11 2a9 9 0 0 1 9 9"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}

interface ToastIconProps {
  type: ToastType;
}

export function ToastIcon({ type }: ToastIconProps) {
  switch (type) {
    case "success": return <SuccessIcon />;
    case "error":   return <ErrorIcon />;
    case "warning": return <WarningIcon />;
    case "info":    return <InfoIcon />;
    case "loading": return <LoadingIcon />;
  }
}
